import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import {
  getDatabaseStats,
  getFlywayMigrations,
  cleanPasswordTokens,
  cleanErrorLogs,
} from '../api/database-admin.api'

export function useDatabaseStats() {
  return useQuery({
    queryKey: ['admin', 'database', 'stats'],
    queryFn: getDatabaseStats,
  })
}

export function useFlywayMigrations() {
  return useQuery({
    queryKey: ['admin', 'database', 'migrations'],
    queryFn: getFlywayMigrations,
  })
}

export function useCleanPasswordTokens() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: cleanPasswordTokens,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'database', 'stats'] })
    },
  })
}

export function useCleanErrorLogs() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (daysThreshold: number) => cleanErrorLogs(daysThreshold),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'database', 'stats'] })
    },
  })
}
